import { Injectable } from '@angular/core';
import { BaseService } from '../core';
import { Faq, FaqListDto } from '../dto';

@Injectable({
  providedIn: 'root',
})
export class FaqService extends BaseService {
  getFaq(faqListDto?: FaqListDto) {
    return super.get<Faq[]>('/faq', faqListDto);
  }

  getFaqById(id: number) {
    return super.get<Faq>(`/faq/${id}`);
  }
}
